<template>
	<div class="modal-card" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">Create a Link</p>
		</header>
		<section class="modal-card-body">
			<o-tabs v-model="activeTab">
				<o-tab-item value="internal" label="Internal link">
					<o-field label="Text" message="Display text for the link.">
						<o-input v-model="text" :placeholder="to"></o-input>
					</o-field>
					<o-field label="Select a page">
						<o-select v-model="to" placeholder="None" expanded>
							<option :value="null">Select existing page</option>
							<option v-for="(o, i) in options" :key="i" :value="o.name">
								{{ o.meta.title }}
							</option>
						</o-select>
					</o-field>
					<o-field
						label="Or enter an existing one"
						message="Will appear in the drop down above if valid.">
						<o-input v-model="to" placeholder="boyden"></o-input>
					</o-field>
					<o-field>
						<o-switch v-model="newTab">Open in a new tab</o-switch>
					</o-field>
				</o-tab-item>
				<o-tab-item value="external" label="External link">
					<o-field label="Text" message="Display text for the link.">
						<o-input v-model="text" :placeholder="url"></o-input>
					</o-field>
					<o-field label="External Link">
						<o-input v-model="url" placeholder="https://www.boyden.net"></o-input>
					</o-field>
					<o-field>
						<o-switch v-model="newTab">Open in a new tab</o-switch>
					</o-field>
				</o-tab-item>
				<o-tab-item value="file" label="Box file">
					<o-field label="Text" message="Display text for the link.">
						<o-input v-model="text"></o-input>
					</o-field>
					<span v-if="file">
						<o-icon icon="paperclip"></o-icon>
						{{ file.name }}
					</span>
					<span v-else>No file attached.</span>
					<div>
						<o-button size="small" @click="OpenBoxFiles">Attach a file</o-button>
					</div>
				</o-tab-item>
				<o-tab-item value="email" label="Email">
					<o-field label="Text" message="Display text for the link.">
						<o-input v-model="text" :placeholder="url"></o-input>
					</o-field>
					<o-field label="Subject">
						<o-input v-model="subject" placeholder="Inquiring about subject"></o-input>
					</o-field>
					<o-field label="To" message="Additional email addresses should be comma separated.">
						<o-input v-model="mail" placeholder="support@boyden.com"></o-input>
					</o-field>
					<o-field label="CC">
						<o-input v-model="cc" placeholder="support@boyden.com"></o-input>
					</o-field>
					<o-field label="BCC">
						<o-input v-model="bcc" placeholder="support@boyden.com"></o-input>
					</o-field>
					<o-field>
						<o-switch v-model="newTab">Open in a new tab</o-switch>
					</o-field>
				</o-tab-item>
			</o-tabs>

			<!-- <code>{{ newTab }}</code> -->
		</section>
		<footer class="modal-card-foot">
			<o-button @click="Confirm" icon-left="link" variant="success" :disabled="isInvalid">
				Insert
			</o-button>
			<o-button variant="light" @click="Close">Cancel</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import store from "@/store";
	import currencyFormat from "@/services/utils/currencyFormat";
	import boxFilesModal from "@/components/modals/boxFilesModal.vue";
	export default {
		emits: ["execute", "close"],
		props: {
			selectedText: {
				type: String,
				default: null
			}
		},
		setup(props, context) {
			const oruga = inject("$oruga");
			const router = useRouter();

			const activeTab = ref("internal");
			const text = ref(props.selectedText);
			const to = ref();
			const url = ref();
			const mail = ref();
			const cc = ref();
			const bcc = ref();
			const subject = ref();
			const newTab = ref(true);
			const file = ref();

			const routes = ref([]);

			const SetRoutes = (r) => {
				routes.value = r.map((row, i, self) => {
					if (self.some((s, j) => s.meta.title === row.meta.title && i !== j)) {
						const split = row.path.split("/");
						row.meta.title = row.meta.title + " " + split[split.length - 2];
					}
					return row;
				});
				routes.value.sort((a, b) => {
					if (a.meta.title < b.meta.title) return -1;
					if (a.meta.title > b.meta.title) return 1;

					return 0;
				});
			};

			const options = computed(() => {
				if (routes.value.length === 0) {
					SetRoutes(router.getRoutes());
					return routes.value;
				} else {
					return routes.value;
				}
			});

			const isInvalid = computed(() => {
				if (activeTab.value == "internal") {
					return !to.value;
				} else if (activeTab.value == "external") {
					return !url.value;
				} else if (activeTab.value == "file") {
					return !file.value;
				} else if (activeTab.value == "email") {
					return !mail.value;
				} else {
					return true;
				}
			});

			const getTabValue = computed(() => {
				switch (activeTab.value) {
					case "internal": {
						return to.value;
					}
					case "external": {
						const uri = url.value.startsWith("http") ? url.value : "https://" + url.value;
						return uri;
					}
					case "file": {
						const uri = document.location.origin + "/api/v2/box/file/" + file.value.id + "/download";
						return {
							uri: uri,
							name: file.value.name
						};
					}
					case "email": {
						let uri = mail.value.startsWith("mailto:") ? mail.value : "mailto:" + mail.value;
						const qs = [
							{ key: "cc", val: cc.value },
							{ key: "bcc", val: bcc.value },
							{ key: "subject", val: subject.value }
						]
							.filter((x) => x.val)
							.map((x) => x.key + "=" + x.val);
						if (qs.length > 0) uri += "?";
						uri += qs.join("&");
						return uri;
					}
					default: {
						return undefined;
					}
				}
			});

			const OpenBoxFiles = () => {
				oruga.modal.open({
					props: {
						select: true
					},
					component: boxFilesModal,
					events: {
						select(result) {
							file.value = result;
						}
					}
				});
			};

			const Close = () => {
				context.emit("close");
			};

			const Confirm = () => {
				const packet = {
					text: text.value,
					tab: activeTab.value,
					v: getTabValue.value,
					newTab: newTab.value
				};
				context.emit("execute", {
					packet: packet,
					close: Close
				});
			};

			return {
				activeTab,
				text,
				to,
				url,
				mail,
				cc,
				bcc,
				subject,
				newTab,
				file,
				options,
				isInvalid,
				OpenBoxFiles,
				Close,
				Confirm
			};
		}
	};
</script>
